import axios from 'axios';
import React from 'react';
// import { createthis.props.history } from "history";
import { connect } from 'react-redux';
import {
    Modal,

} from 'react-bootstrap';
import classNames from 'classnames';
import { bindActionCreators } from 'redux';
import validator from './../common/validator.js';
import * as SVGICONS from '../../images/img/images';
import * as signinActions from '../../actions/signinActions';
import { ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
// import { history } from '../../store/configureStore';

var countries = require('country-data').countries;
const autoBind = require('auto-bind');
//login container component
class OtpModal extends React.Component {
    constructor(props, context) {
        super(props, context);
        this.state = {
            forgotModalOpen: false,
            spinner: false,
            userType: { value: '1', isValid: true, message: '' },
            email: { value: '', isValid: true, message: '' },
            password: { value: '', isValid: true, message: '' },
            Ip: '',
            otp: { value: '', isValid: true, message: '' },
            resendOTP: false
        };
        //binding current context to all functions
        this.onChange = this.onChange.bind(this);
        this.onSigninHandler = this.onSigninHandler.bind(this);
        this.onOtpSubmit = this.onOtpSubmit.bind(this);
        this.resendOTP = this.resendOTP.bind(this)

    }


    onOtpSubmit() {
		this.setState({resendOTP: false})

        let obj = {
            userId: this.state.loginData._id,
            loginKey: this.state.otp.value
        }

        this.props.actions.otpVerification(obj);

    }
    onChange(e) {
        var state = this.state;
        state[e.target.name].value = e.target.value;
        // this.resetValidationStates();
        if (e.target.name == "email") {
            if (e.target.value.length > 0) {
                if (!validator.isEmail(state.email.value)) {
                    state.email.isValid = false;
                    state.email.message = 'Not a valid email address';
                    this.setState(state);
                } else {
                    return true
                }
            } else {
                state.email.isValid = false;
                state.email.message = 'Email address is required';
                this.setState(state);
            }

        } else
            if (e.target.name == "password") {
                if (e.target.value.length > 0) {
                    if (!validator.isValid(state.password.value)) {
                        state.password.isValid = false;
                        state.password.message = 'Not a valid password';
                        this.setState(state);
                    } else {
                        return true
                    }
                } else {
                    state.password.isValid = false;
                    state.password.message = 'Password is required';
                    this.setState(state);
                }
            } else if (e.target.name == "userType") {
                return true
            }

        this.setState(state);
    }

    //Handler for sign-in
    onSigninHandler(event) {


        event.preventDefault();
        var state = this.state;
        if (!validator.isValid(parseInt(state.userType.value))) {
            state.userType.isValid = false;
            state.userType.message = 'Please select user type';
        } else {
            state.userType.isValid = true;
            state.userType.message = '';
        }
        if (!validator.isValid(state.email.value)) {
            state.email.isValid = false;
            state.email.message = 'Email address is required';
            this.setState(state);
        } else {
            state.email.isValid = true;
            state.email.message = '';
        }
        if (!validator.isValid(state.password.value)) {
            state.password.isValid = false;
            state.password.message = 'Password is required';
            this.setState(state);
        } else {
            state.password.isValid = true;
            state.password.message = '';
        }
        if (this.state.email.value != '' && this.state.password.value != '' && this.state.userType.value != '' && (this.state.email.message == '' || this.state.email.message == undefined) && (this.state.password.message == '' || this.state.password.message == undefined) && (this.state.userType.message == '' || this.state.userType.message == undefined)) {
            // debugger
            var signin = {
                email: this.state.email.value.toLowerCase(),
                password: this.state.password.value,
                userType: parseInt(this.state.userType.value),
                Ip: this.state.Ip
            }
            this.setState({ spinner: true })
            this.props.actions.signinUser(signin, this.props);

        }
    }



    componentWillReceiveProps = (nextProps) => {
        // debugger;
        if (nextProps.signup) {

            this.setState({ spinner: false })
            this.props.hideSignupModal()
        } else {
            this.setState({ spinner: false })
        }
        if (nextProps.signin == 'failed') {
            this.setState({ spinner: false })

        }
        if (!this.state.resendOTP && nextProps.otpVerified && nextProps.otpVerified.success) {
            toast.info("Logged in Successfully");
            if (this.props.dispute) {
            toast.info("don not redirect");
            localStorage.setItem("token", this.state.loginData.token);
            localStorage.setItem("userId", this.state.loginData._id);
            localStorage.setItem("user", JSON.stringify(this.state.loginData));
            localStorage.setItem("userType", this.state.loginData.type);
            this.props.history.push(`/disputes/${this.props.match.params.appointmentId}`)
            this.props.closeOtpModal();
            }else
            if (this.state.loginData.type == 'patient') {

                localStorage.setItem("token", this.state.loginData.token);
                localStorage.setItem("userId", this.state.loginData._id);
                localStorage.setItem("user", JSON.stringify(this.state.loginData));
                localStorage.setItem("userType", this.state.loginData.type);
                toast.info("Logged in Successfully");

                if (
                    // this.state.loginData.userName == undefined &&
                    this.state.loginData.gender == undefined &&
                    this.state.loginData.dateOfBirth == null
                ) {
                    toast.info("Logged in Successfully");
                    this.props.closeOtpModal();
                    this.props.history.push('/dashboard/my-setting')
                    // this.props.hideSignupModal();
                    // this.props.hideSigninModal();
                    
                    // if(localStorage.setItem("user", JSON.stringify(this.state.loginData)) !== null)
                    // this.context.history.push('/path')
                        // history.push("/dashboard");
                        // this.props.history.push("/dashboard/my-setting");

                } else {
                    localStorage.setItem("feedbackRemind", true);
                    if (
                        localStorage.getItem("availabilityId") &&
                        (localStorage.getItem("availabilityId") != null &&
                            localStorage.getItem("availabilityId") != "") &&
                        localStorage.getItem("fromMarketPage") &&
                        (localStorage.getItem("fromMarketPage") != null &&
                            localStorage.getItem("fromMarketPage") != false)
                    ) {
                        toast.info("Logged in Successfully");

                        this.props.history.push("/dashboard/book-appointment-calendar");
                    } else {
                        toast.info("Logged in Successfully");

                        this.props.history.push("/dashboard/my-appointment");
                    }

                }
            } else if (this.state.loginData.type == 'specialist') {
                localStorage.setItem("token", this.state.loginData.token);
                localStorage.setItem("userId", this.state.loginData._id);
                localStorage.setItem("user", JSON.stringify(this.state.loginData));
                localStorage.setItem("userType", this.state.loginData.type);
                toast.info("Logged in Successfully");

                if (
                    this.state.loginData.userName == undefined ||
                    this.state.loginData.gender == undefined ||

                    this.state.loginData.availabilityCount == 0 ||

                    this.state.loginData.isVerified != "2") {
                    this.props.history.push("/specialist/my-profile");
                } else {
                    this.props.history.push("/specialist/my-appointment");
                }
            }
            else if (this.state.loginData.role_id.status == 3) {
                var UserRoles = this.state.loginData.filtered;
                localStorage.setItem("token", this.state.loginData.token);
                localStorage.setItem("userId", this.state.loginData._id);
                localStorage.setItem('user', JSON.stringify(this.state.loginData));
                localStorage.setItem('roles', this.state.loginData.filtered)

                if (this.state.loginData.role_id.status == 3) {

                    if (UserRoles.indexOf('finance') != -1) {
                        this.props.history.push("/user/finance-dashboard");
                        // toast.info( this.state.loginData.message);
                    }
                    if (UserRoles.indexOf('feedback') != -1) {
                        this.props.history.push("/user/feedbacks");
                        // toast.info(response.data.message);
                    }

                    if (UserRoles.indexOf('specialistuser') != -1 || UserRoles.indexOf('vetting') != -1) {
                        this.props.history.push("/user/specialistuser");
                        toast.info('Signed in successfully');
                    }
                    if (UserRoles.indexOf('photouser') != -1) {
                        this.props.history.push("/user/Images");
                        toast.info('Signed in successfully');
                    }
                    if (UserRoles.indexOf('patientuser') != -1) {
                        this.props.history.push("/user/patients");
                        toast.info('Signed in successfully');
                    }
                    if (UserRoles.indexOf('specialistAssisstant') != -1) {
                        this.props.history.push("/user/specialist-assisstant");
                        toast.info('Signed in successfully');
                    }
                    if (UserRoles.indexOf('admin') != -1) {
                        this.props.history.push("/user/superuser-dashboard");
                        toast.info('Signed in successfully');
                    }
                } else if (nextProps.response.data.data.type == 'user') {
                    this.props.history.push("/user/superuser-dashboard");
                    toast.info('Signed in successfully')
                } else if (nextProps.response.data.data.type == 'user') {
                    this.props.history.push("/user/superuser-dashboard");
                    toast.info('Signed in successfully')
                }

            }
        }
        else {
            // toast.info(nextProps.otpVerified.message);
        }
        if (nextProps.resendOTP) {
			this.setState({ spinner: false })
		}
    }

    componentDidMount() {
    }

    componentWillMount() {
        this.setState({
            loginData: this.props.loginData
        })
        navigator.geolocation.getCurrentPosition(
            function (position) {
                var lat = position.coords.latitude;
                var lng = position.coords.longitude;
                localStorage.setItem('lat', lat);
                localStorage.setItem('lng', lng);
                axios.get('https://maps.googleapis.com/maps/api/geocode/json?latlng=' + lat + "," + lng + '&key=AIzaSyBQQtO5Ia-kb95LB-pBnKeBDeN35Z2ybbk')
                    .then(function (response) {
                        if (response) {
                            for (var i = 0; i < response.data.results.length; i++) {
                                if (response.data.results[i].types[0] == 'country') {
                                    var countryshort = response.data.results[i].address_components[0].short_name;
                                    var countrylong = response.data.results[i].address_components[0].long_name;

                                    localStorage.setItem('country_short', countryshort)
                                    localStorage.setItem('country_long', countrylong)
                                    localStorage.setItem('currency', countries[countryshort].currencies[0]);
                                    localStorage.setItem('calling_code', countries[countryshort].countryCallingCodes[0]);
                                    localStorage.removeItem('mileDistance', 0)
                                }
                            }
                        }
                        else {
                        }
                    })
            });
    }
    resendOTP() {
		this.setState({resendOTP : true})
		let resendData = {
            ...this.props.loginData.signinData,
			resendOTP: true,
		}
        // return;
		this.props.actions.resendOtpVerification(resendData);
	}

    render() {

        // this.props.history.push("/dashboard")
        var { email, password } = this.state;
        return (
            <Modal show={this.props.otpModalOpen} size="modal-sm" onHide={this.props.closeOtpModal}>
                <Modal.Header>
                    {/* <ModalClose onClick={} /> */}
                    <Modal.Title><img src={require('../../images/images/logo.svg')} alt="" /></Modal.Title>
                    {/* <img src={require('../../images/images/logo.svg')} alt="" /> */}
                </Modal.Header>
                <Modal.Body>

                    <div className="signIn "> Enter your OTP</div>
                    <div className="userSpecialist">
                    </div >
                    <div className="loginInput">
                        <div className="input-group">
                            <div className="input-group-prepend">
                                <span className="input-group-text" id="inputGroupPrepend">
                                    <SVGICONS.EmailSvg />
                                </span>
                            </div>
                            <input autoComplete="new-password" type="text" name="otp" className="form-control"
                                placeholder="Enter OTP" value={this.state.otp.value} onChange={this.onChange} autoFocus defaultValue="" />
                            <span className="help-block">{email.message}</span>
                            <span style={{ color: '#52b5eb', textAlign: 'center', marginLeft:"33px" }}>Have not received an OTP yet? <a href="#" onClick={this.resendOTP}> Resend Code</a></span>
                        </div>
                        {/* <ToastContainer /> */}

                        <div className="btngrouplogIn">
                            <button className="btn btn-primary btn-signup" data-toggle="modal" onClick={this.onOtpSubmit}> Submit {this.state.spinner ? <i className="fa fa-spinner fa-spin" /> : ""}</button>
                        </div>

                    </div>

                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal >
        );
    }
}
{/* //this tells what state should expose on props  */ }
function mapStateToProps(state, ownProps) {
    return {
        signin: state.signin,
        otpVerified: state.signin.otpVerified
    };
}

//bindActionCreators is used to bind all actions at once
function mapDispatchToProps(dispatch) {
    return {
        actions: bindActionCreators(signinActions, dispatch)
    };
}
export default connect(mapStateToProps, mapDispatchToProps)(OtpModal);
